module.exports = __webpack_public_path__ + "static/img/daily-check-in.407e5a3a.png";